/**
 * EAN-13 kontrol hanesi ve GTS'in kendi ürettiği dahili barkodlar.
 *
 * Barkod alanı boş bırakılan ürünlere sistem barkod üretiyor. Bu barkodun
 * **geçerli bir EAN-13** olması şart: etiket basarken EAN-13 seçilirse
 * `barcodeRenderer` gövdeyi 12 haneye kırpıp kontrol hanesini kendisi
 * hesaplıyor. Üretilen değer 13 hane ve doğru kontrol hanesine sahip değilse
 * basılan barkod üründe kayıtlı olandan farklı çıkıyor ve etiket okutulduğunda
 * ürün bulunamıyor.
 */

/**
 * `02` prefix'i EAN-13'te mağaza içi kullanıma ayrılmış aralıktan.
 *
 * Tartı etiketleri `20`–`29` aralığını kullanıyor (CL3000 fabrika ayarı `27`).
 * Kasada ağırlık barkodu çözücüsü prefix'e bakarak karar verdiği için GTS'in
 * ürettiği barkod o aralığa girmemeli; aksi halde normal bir ürün ağırlık
 * etiketi sanılır.
 */
const INTERNAL_PREFIX = '02';

/** EAN-13 kontrol hanesi: tek pozisyonlar 1x, çift pozisyonlar 3x ağırlıklı. */
export function ean13CheckDigit(body12: string): number {
  let sum = 0;
  for (let i = 0; i < 12; i++) {
    const digit = body12.charCodeAt(i) - 48;
    sum += i % 2 === 0 ? digit : digit * 3;
  }
  return (10 - (sum % 10)) % 10;
}

/**
 * Barkodu boş bırakılan ürünler için geçerli bir EAN-13 üretir.
 *
 * Gövde: `02` + zaman damgasının son 8 hanesi + 2 hane rastgele. Aynı
 * milisaniyede iki ürün eklense bile rastgele kısım ayırıyor; ayrıca kaydetme
 * öncesi barkod çakışma kontrolü zaten çalışıyor.
 */
export function generateInternalBarcode(): string {
  const stamp = Date.now().toString().slice(-8);
  const noise = Math.floor(Math.random() * 100).toString().padStart(2, '0');
  const body = `${INTERNAL_PREFIX}${stamp}${noise}`;
  return `${body}${ean13CheckDigit(body)}`;
}
